export {default as voronoi} from "./src/voronoi";



//////////////////
// WEBPACK FOOTER
// ./~/vue-d3/~/d3-voronoi/index.js
// module id = +oP+
// module chunks = 0